<template>
  <div class="uk-width-3-4@m uk-text-left">
    <div class="uk-container uk-container-small">
      <div class="uk-section">
        <ul class="uk-list">
          <li
            v-for="item in items"
            v-bind:key="item.id"
            class="uk-padding-small uk-margin-bottom bg_orange text_white f26 cut_edge_small scale list"
          >
            <router-link
              :to="{ name: 'Single', params: { item_id: item.id } }"
              class="text_white"
            >
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.items = this.$store.state.items
  },
  data() {
    return {
      items:[]
    }
  }
}
</script>